import { render, staticRenderFns } from "./guest-pqat-main.vue?vue&type=template&id=4796fee2&"
import script from "./guest-pqat-main.vue?vue&type=script&lang=js&"
export * from "./guest-pqat-main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports